<template>
  <v-dialog
      v-model="showForm"
      max-width="400px"
      transition="dialog-top-transition"
      persistent
  >
    <v-card>
      <v-toolbar fixed dark color="primary">
        <v-toolbar-title>
          <h4 class="title">{{title}}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="closed"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form>
        <v-card-text>
          <div class="md-layout">
            <div >
              <v-text-field
                  v-model="guardia.nombre"
                  label="Nombre"
              />
              <v-text-field
                  v-model="guardia.apellidoPaterno"
                  label="Primer Apellido"
              />
              <v-text-field
                  v-model="guardia.apellidoMaterno"
                  label="Segundo Apellido"
              />
              <v-text-field
                  v-model="guardia.celular"
                  label="Número Celular"
              />
              <v-autocomplete
                  v-model="guardia.domicilio"
                  :items="domicilios"
                  item-text="nombre"
                  item-value="id"
                  label="Seleccionar Domicilio"
                  chips
                  clearable
                  deletable-chips
                  small-chips
                  hint="Domicilio"
                  persistent-hint

              >
              </v-autocomplete>
              <v-autocomplete
                  v-model="empresa"
                  :items="empresas"
                  item-text="nombre"
                  item-value="id"
                  label="Selecciona la Empresa"
                  chips
                  hint="Empresa"
                  persistent-hint
              ></v-autocomplete>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="terciary" dark @click="closed">
            Cancelar
          </v-btn>
          <v-btn v-if="title==='Actualizar Guardia'" color="secondary" @click="update" :loading="loading">
            Actualizar
          </v-btn>
          <v-btn v-else color="secondary" @click="create" :loading="loading">
            Crear
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "GuardiaForm",
  props: {
    title: String,
    guardia: {},
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  data: ()=>({
    loading: false,
    empresa: {},
  }),
  computed: {
    ...mapGetters(['empresas','domicilios']),
  },
  mounted() {
    this.empresa = this.guardia.empresa ? this.guardia.empresa.id : null ;

  },
  methods: {
    async create() {
      this.loading= true;
      this.guardia.empresa = this.empresa;
      this.guardia.domicilio = "RG9taWNpbGlvVHlwZToy";
      await this.$store.dispatch('createGuardia', this.guardia);
      this.loading= false;
      this.closed();
    },
    async update() {
      this.loading= true;
      this.guardia.empresa = this.empresa;
      this.guardia.domicilio = "RG9taWNpbGlvVHlwZToy";
      await this.$store.dispatch('updateGuardia', this.guardia);
      this.loading= false;
      this.closed();
    },
    closed() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>

</style>
